import React, { PropsWithChildren, ReactElement } from "react";
import "./index.scss";

type Props = {
  componentToRenderInEmptySpace?: ReactElement;
  isDisplayingBackButton?: boolean;
};

const ContainerBox = (props: PropsWithChildren<Props>) => {
  function renderComponentInEmptySpace() {
    return props.componentToRenderInEmptySpace
      ? props.componentToRenderInEmptySpace
      : null;
  }

  return (
    <div className="ContainerBox">
      <div
        style={{ height: 50 }}
        className={props.isDisplayingBackButton ? "neo-back-button" : ""}
      >
        {renderComponentInEmptySpace()}
      </div>
      <div>
        {props.children}
      </div>
    </div>
  );
};

export default ContainerBox;
